// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Lq-z","imageAndVideoCount":"Mq-z","imageAndVideoContainer":"Nq-z","viewAllReviews":"Oq-z"};